const METHOD_CHANGE_STATUS = 'changeStatus';

export default METHOD_CHANGE_STATUS;
